import { render, staticRenderFns } from "./AsiBooleanIcon.vue?vue&type=template&id=2db1e129&scoped=true"
import script from "./AsiBooleanIcon.vue?vue&type=script&lang=ts"
export * from "./AsiBooleanIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db1e129",
  null
  
)

export default component.exports